import React from 'react'
import { useTranslation } from 'react-i18next'
import Part from '../../../components/HomePart'
import img from '../../../assets/img/model.svg'
import './style.scss'

const Model: React.FC = () => {
  const { t } = useTranslation('trans', { keyPrefix: 'model' })

  return (
    <Part id="model" title={t('title')}>
      <div className="description">
        <img src={img} alt="" />
      </div>
    </Part>
  )
}

export default Model
